<template>
    <div>
        <div>
            <b-alert variant="danger" dismissible v-model="showPasswordError">
                Invalid Username and/or Password!
            </b-alert>
            <b-alert variant="danger" dismissible v-model="showOtherError">
                Connection Error!
            </b-alert>
            <b-progress :value="counter" :max="max"  animated v-show="busy2" />
            <b-card-group deck>
                <b-card
                        header="Welcome, find your tenant balances here"
                        header-tag="header"
                        title="Login Form"
                >
                    <b-card-body>
                        <b-form @submit.prevent="submitLogin" @reset="onReset" v-if="show">
                            <b-form-group
                                    id="labelformEmail"
                                    label="Username:"
                                    label-for="formEmail"
                                    description=""
                            >
                                <b-form-input
                                        id="formEmail"
                                        type="text"
                                        v-model="form.username"
                                        required
                                        placeholder="Enter Username"/>
                            </b-form-group>

                            <b-form-group id="labelformPassword" label="Password:" label-for="formPassword">
                                <b-form-input
                                        id="formPassword"
                                        type="password"
                                        v-model="form.password"
                                        required
                                        placeholder="Enter Password"/>
                            </b-form-group>

                            <b-button type="submit" variant="primary">Login</b-button>
                            <b-button type="reset" variant="danger">Reset</b-button>
                        </b-form>
                        <br/>
                    </b-card-body>
                    <div slot="footer">Click here if you <a href="#" @click.prevent="showForgot">forgot your
                        password</a></div>
                </b-card>

            </b-card-group>
        </div>

        <!-- Modal Component -->
        <b-modal ref="forgotModal" id="modal1" title="Forgot Password Form">

            <b-form-group
                    id="labelformForgot"
                    label="Registered Email Address:"
                    label-for="formForgot"
                    description=""
            >
                <b-form-input
                        id="formForgot"
                        type="email"
                        v-model="form.forgot"
                        required
                        placeholder="Enter Email Address"/>
            </b-form-group>
            <vue-recaptcha :sitekey="this.sitekey" @verify="onVerify">
            </vue-recaptcha><br/>
            <b-progress :value="counter" :max="max"  animated v-show="busy" />
            <b-alert variant="danger" dismissible v-model="showForgotErrors">
                {{ forgotResults }}
            </b-alert>
            <div slot="modal-footer">
                <b-button v-on:click="submitForgot" variant="primary" :disabled="forgotState">Recover Password</b-button>
            </div>
        </b-modal>

    </div>
</template>

<script>
    import axios from 'axios';
    import VueRecaptcha from 'vue-recaptcha';

    export default {
        data() {
            return {
                sitekey: '6LdS2ZIUAAAAAEh9E5s7X5mWTP2g2Xl5LwfErbQ3',
                form: {
                    username: '',
                    password: '',
                    forgot: ''
                },
                showPasswordError: false,
                showOtherError: false,
                showForgotErrors: false,
                show: true,
                errors: [],
                validated: false,
                forgotResults: '',
                counter: 100,
                max: 100,
                busy: false,
                busy2: false
            }
        },
        computed: {
            forgotState() {
                return !this.validated || this.form.forgot.length < 3;
            }
        },
        created() {

        },
        methods: {

            submitForgot() {
                this.busy = true;
                this.showForgotErrors = false;
                let email = this.form.forgot;
                let url = this.apihost + "rreqpass?fromname=@FORGOT@&frommail=" + email + "&user=" + email;
                let parent = this;
                axios.post(url)
                    .then(rs=>{
                        parent.showForgotErrors = true;
                        parent.forgotResults = rs.data.Message;
                        parent.busy = false;
                    })
                    .catch(e=>{
                        parent.showForgotErrors = true;
                        parent.forgotResults = "Connection Error!";
                        parent.busy = false;
                        console.log(e);
                    })

            },
            showForgot() {
                this.$refs.forgotModal.show()
            },
            submitLogin() {
                this.showPasswordError = false;
                this.showOtherError = false;
                this.busy2 = true;
                let url = this.apihost + "rlogin?uid="+this.form.username+"&pwd="+this.form.password;
                axios.post(url)
                    .then(rs => {
                        this.busy2 = false;
                        console.log(rs.data);
                        if (rs.data && rs.data.rst === "Logged In!") {
                            this.$emit('login_success', rs.data);
                        } else {
                            this.showPasswordError = true;
                        }
                    })
                    .catch(e => {
                        this.busy2 = false;
                        this.showOtherError = true;
                        console.log(e);
                    })

            },
            onReset(evt) {
                evt.preventDefault()
                this.form.username = '';
                this.form.password = '';
            },
            onVerify: function (response) {
                // console.log('Verify: ' + response)
                this.validated = true;
            },
        },
        components: {
            VueRecaptcha
        }
    }
</script>
